//initial js

import { select2 } from "select2";

export default class Courses {
    domesticButton = $("#domestic");
    internationalButton = $("#international");
    isStudentTypeClicked = false;
    selectedStudentType = null;
    atar = "";
    cricos = "";
    courseType = "";
    courseCode = "";
    selectCountryElemOriginal = $("#select-country");
    selectCountryElem = null;
    inputRadioEntryPath = $("input[name=entry-path]");
    handbookUrlBase = ""; //"https://murdoch-uatpreview-handbook.factor5-curriculum.com.au/";
    howToApplyUrl = ""; //'https://www.murdoch.edu.au/study/apply-to-murdoch';
    isWildcard = "";
    websiteUrl = location.origin;
    isCourseAndMajor = false;
    str_australia = "australia";
    discipline = "";
    domesticRequirementTables = $(".domesticRequirements");

    tabButtons = $("button.tablink");
    activeTabIndex = 0;

    constructor() {
        console.log("Courses component loaded");
        // console.log('jquery version Courses', $.fn);
        // console.log('window jquery', window.jQuery.fn);
        // console.log('global jquery', global.$);
        // console.log('select2', select2);

        this.initCustomDropdown();

        $(window).on("keyup", (e) => this.cycleThroughTabs(e));
        this.domesticButton.on("click", () =>
            this.domesticButtonEventHandler()
        );
        this.internationalButton.on("click", () =>
            this.internationalButtonEventHandler()
        );

        $(".higher-education").on("click", () =>
            this.displayDomesticHigherEducation()
        );
        $(".secondary-education").on("click", () =>
            this.displayDomesticSecondaryEducation()
        );
        $(".vet-course").on("click", () => this.displayDomesticVetCourse());
        $(".work-life-experience").on("click", () =>
            this.displayDomesticWorkLifeExperience()
        );

        this.inputRadioEntryPath.on("change", (e) => {
            e.preventDefault();
            this.entryPathOnChangeEventHandler();
        });

        $(window).on("resize", () => this.windowResizeEventHandler());
        this.windowResizeEventHandler();

        // Condition seems unnecessary if bundle only loaded on course and major pages
        if (typeof isCourseAndMajorPage != "undefined") {
            this.initSelect2();

            if ($('#select-country').length) {
                this.selectCountryElem = $('#select-country').select2({
                    searchInputPlaceholder: 'Search country',
                    width: "300px"
                });

                $('#select-country').on('change', () =>
                    this.selectCountryOnChangeEventHandler()
                );
            }

            this.initCoursesAndMajors();
            this.isStudentTypeClicked = this.getCookie("isStudentTypeClicked");
            this.initKeyDetails();
            this.initTabOverview();
            this.initTabEntryRequirement();
            this.initTabFeeAndScholarship();
            // this.initPagination();
            this.handleStudentTypeSelection();
            // this.toggleStudentTypeElements();
            // this.initProgressPath();
        }
    }

    initCoursesAndMajors() {
        this.atar = getAtar();
        this.cricos = getCricos();
        this.courseType = getCoursesAndMajorsType();
        this.courseCode = getCourseCode();
        this.handbookUrlBase = getHandbookStructureUrl();
        this.howToApplyUrl = getLinkToApplyUrl();
        this.isWildcard = getIsWildcard();
        this.discipline = getDiscipline();
    }

    initKeyDetails() {
        if (this.isStudentTypeClicked) {
            this.selectedStudentType = this.getStudentTypeCookie();
            if (this.selectedStudentType == "domestic") {
                this.domesticButton.trigger("click");
            } else if (this.selectedStudentType == "international") {
                this.internationalButton.trigger("click");
            }
        } else {
            $("#student-type-question").show();
        }
    }

    initTabOverview() {
        this.displayActiveOfferings();
    }

    initInternationalEntryRequirement() {
        this.websiteUrl = this.websiteUrl.replace(
            "www.murdoch.edu.au",
        );
    }

    initTabEntryRequirement() {
        this.initInternationalEntryRequirement();
        this.domesticRequirementTables.hide();

        if (this.courseType) {
            this.displaySelectorCountry(this.courseType);
            this.displayOnshoreRequirement(this.courseType);
            this.displaySpecialRequirement(this.courseType);
        }

        this.displayInternationalEntryRequirementsByCountry(this.str_australia);
        this.displayGenericAdmission();

        if (this.selectCountryElem?.length) {
            this.selectCountryOnChangeEventHandler();
        }
    }

    initTabFeeAndScholarship() {
        if (this.isStudentTypeClicked) {
            this.toggleFeesAndScholarshipVisibility(this.selectedStudentType);
        } else {
            this.toggleFeesAndScholarshipVisibility("domestic");
        }
    }

    // initPagination() {
    //     $(".pagination").hide();
    // }

    initSelect2() {
        var Defaults = $.fn.select2.amd.require("select2/defaults");
        $.extend(Defaults.defaults, {
            searchInputPlaceholder: "",
        });
        var SearchDropdown = $.fn.select2.amd.require(
            "select2/dropdown/search"
        );
        var _renderSearchDropdown = SearchDropdown.prototype.render;
        SearchDropdown.prototype.render = function (decorated) {
            // invoke parent method
            var $rendered = _renderSearchDropdown.apply(
                this,
                Array.prototype.slice.apply(arguments)
            );
            this.$search.attr(
                "placeholder",
                this.options.get("searchInputPlaceholder")
            );
            return $rendered;
        };
    }

    initCustomDropdown() {
        const dropdowns = document.querySelectorAll('[data-mu-dropdown]');
        if (!dropdowns.length) return;

        dropdowns.forEach((dropdown) => {
            const select = dropdown.querySelector('select');
            const selected = dropdown.querySelector('[data-dropdown-selected]');
            const menu = dropdown.querySelector('[data-dropdown-menu]');

            if (!select || !selected || !menu) return;

            function buildDropdown() {
                menu.innerHTML = "";

                [...select.options].forEach((option, index) => {
                    const item = document.createElement('div');
                    item.className = 'mu-dropdown__item';
                    item.textContent = option.textContent;
                    item.setAttribute('role', 'option');

                    if (index === select.selectedIndex) {
                        item.classList.add('active');
                        selected.textContent = option.textContent;
                    }

                    item.addEventListener('click', (e) => {
                        e.stopPropagation();

                        select.selectedIndex = index;
                        select.dispatchEvent(new Event('change', { bubbles: true }));

                        setSelected(option.textContent, item);
                        closeDropdown();
                    });

                    menu.appendChild(item);
                });

                if (!selected.textContent && select.options.length) {
                    selected.textContent = select.options[select.selectedIndex].textContent;
                }
            }

            function setSelected(label, activeItem) {
                selected.textContent = label;
                menu.querySelectorAll('.mu-dropdown__item')
                    .forEach(i => i.classList.remove('active'));
                activeItem.classList.add('active');
            }

            function openDropdown() {
                dropdown.classList.add('open');
                dropdown.setAttribute('aria-expanded', 'true');
            }

            function closeDropdown() {
                dropdown.classList.remove('open');
                dropdown.setAttribute('aria-expanded', 'false');
            }

            selected.addEventListener('click', (e) => {
                e.stopPropagation();
                dropdown.classList.contains('open') ? closeDropdown() : openDropdown();
            });

            selected.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    openDropdown();
                }
                if (e.key === 'Escape') {
                    closeDropdown();
                }
            });

            select.addEventListener('change', () => {
                const value = select.value;
                const target = document.getElementById(value);

                if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                }

                const selectedOption = select.options[select.selectedIndex];
                console.log(selectedOption.dataset);
            });

            buildDropdown();
        });

        document.addEventListener('click', (e) => {
            document.querySelectorAll('[data-mu-dropdown]').forEach(dropdown => {
                if (!dropdown.contains(e.target)) {
                    dropdown.classList.remove('open');
                    dropdown.setAttribute('aria-expanded', 'false');
                }
            });
        });
    }

    cycleThroughTabs(e) {
        switch (e.which) {
            case 37:
                //console.log('left arrow');
                if (this.activeTabIndex == 0) {
                    this.activeTabIndex = this.tabButtons.length - 1;
                } else this.activeTabIndex--;
                this.tabButtons[this.activeTabIndex].click();
                break;
            //case 38:
            //    console.log('up arrow');
            //    break;
            case 39:
                //console.log('right arrow');
                if (this.activeTabIndex == this.tabButtons.length - 1)
                    this.activeTabIndex = 0;
                else this.activeTabIndex++;
                this.tabButtons[this.activeTabIndex].click();
                break;
            //case 40:
            //    console.log('down arrow');
            //    break;
            default:
                return;
        }
        e.preventDefault();
    }

    // TODO: Replace with session-based student type handler (handleStudentTypeSelection)
    domesticButtonEventHandler() {
        this.selectedStudentType = "domestic";
        this.setCookie("isStudentTypeDomestic", true, 30);
        this.setCookie("isStudentTypeClicked", true, 30);
        this.displayActiveOfferings();
        this.displayGenericAdmission();
        this.toggleFeesAndScholarshipVisibility(this.selectedStudentType);
        this.modifyEnquiryParam(this.selectedStudentType);
    }

    internationalButtonEventHandler() {
        this.selectedStudentType = "international";
        this.setCookie("isStudentTypeDomestic", false, 30);
        this.setCookie("isStudentTypeClicked", true, 30);
        this.displayActiveOfferings();
        this.displayGenericAdmission();
        this.toggleFeesAndScholarshipVisibility(this.selectedStudentType);
        this.modifyEnquiryParam(this.selectedStudentType);
    }

    selectCountryOnChangeEventHandler() {
        if(!this.selectCountryElem?.length) {
            return;
        }

        const country = this.selectCountryElem.val();

        if(typeof country !== "string") {
            return;
        }
        
        const countryName = country.toLowerCase().trim();

        this.displayInternationalEntryRequirementsByCountry(countryName);

        this.inputRadioEntryPath.prop("checked", false);

        const isAustralia = country === this.str_australia;

        const countryType = isAustralia
            ? "domestic"
            : "international";

        $("[data-country-type]").hide();
        $(`[data-country-type="${countryType}"]`).show();

        if (isAustralia) {
            $("#genericAdmissionContentBlock").show();
            $("#genericAdmissionContentBlock-International").hide();
            $("#header-pathOption").show();
            $(".path-option").show();
            $("#internationalRequirements-mobile table").remove();
            $("#internationalRequirements tbody > tr").remove();
        } else {
            $("#genericAdmissionContentBlock-International").show();
            $("#genericAdmissionContentBlock").hide();
            $("#header-pathOption").hide();
            $(".path-option").hide();
        }
    }

    entryPathOnChangeEventHandler() {
        console.log("entryPathOnChangeEventHandler");
        this.domesticRequirementTables.hide();
        let checkedElem = $("input[name=entry-path]:checked")[0];
        if (checkedElem) {
            console.log("checkedElem", checkedElem);
            let id = checkedElem.id;
            $(".domesticRequirements-" + id).show();
        }
    }

    // TODO: I don't understand why the tbody elements are being targeted instead of the tables themselves
    // Too much work to refactor right now though

    windowResizeEventHandler() {
        let desktopBodies =
            this.domesticRequirementTables.find("tbody:not(.mobile)");
        let mobileBodies =
            this.domesticRequirementTables.find("tbody.mobile");

        let desktopHeads =
            this.domesticRequirementTables.find("thead:not(.mobile)");
        let mobileHeads =
            this.domesticRequirementTables.find("thead.mobile");

        if (window.innerWidth >= 900) {
            desktopBodies.show();
            desktopHeads.show();

            mobileBodies.hide();
            mobileHeads.hide();

            $("#internationalRequirements").show();
            $("#internationalRequirements > tbody").show();
            $("#internationalRequirements-mobile").hide();
        }

        if (window.innerWidth < 900) {
            mobileBodies.show();
            mobileHeads.show();

            desktopBodies.hide();
            desktopHeads.hide();

            $("#internationalRequirements").hide();
            $("#internationalRequirements-mobile").show();
        }
    }

    displayDomesticHigherEducation() {
        if (!this.domesticRequirementTables.length) return;

        let desktop =
            this.domesticRequirementTables.find(
                ".domesticRequirements-higher-education thead:not(.mobile), " +
                ".domesticRequirements-higher-education tbody:not(.mobile)"
            );

        let mobile =
            this.domesticRequirementTables.find(
                ".domesticRequirements-higher-education thead.mobile, " +
                ".domesticRequirements-higher-education tbody.mobile"
            );

        if (window.innerWidth >= 900) {
            desktop.show();
            mobile.hide();
        } else {
            mobile.show();
            desktop.hide();
        }

        $(".domesticRequirements-secondary-education").hide();
        $(".domesticRequirements-vet-course").hide();
        $(".domesticRequirements-work-life-experience").hide();
    }

    displayDomesticSecondaryEducation() {
        if (!this.domesticRequirementTables.length) return;

        $(".domesticRequirements-higher-education").hide();

        let desktop =
            this.domesticRequirementTables.find(
                ".domesticRequirements-secondary-education thead:not(.mobile), " +
                ".domesticRequirements-secondary-education tbody:not(.mobile)"
            );

        let mobile =
            this.domesticRequirementTables.find(
                ".domesticRequirements-secondary-education thead.mobile, " +
                ".domesticRequirements-secondary-education tbody.mobile"
            );

        if (window.innerWidth >= 900) {
            desktop.show();
            mobile.hide();
        } else {
            mobile.show();
            desktop.hide();
        }

        $(".domesticRequirements-vet-course").hide();
        $(".domesticRequirements-work-life-experience").hide();
    }

    displayDomesticVetCourse() {
        if (!this.domesticRequirementTables.length) return;

        $(".domesticRequirements-higher-education").hide();
        $(".domesticRequirements-secondary-education").hide();

        let desktop =
            this.domesticRequirementTables.find(
                ".domesticRequirements-vet-course thead:not(.mobile), " +
                ".domesticRequirements-vet-course tbody:not(.mobile)"
            );

        let mobile =
            this.domesticRequirementTables.find(
                ".domesticRequirements-vet-course thead.mobile, " +
                ".domesticRequirements-vet-course tbody.mobile"
            );

        if (window.innerWidth >= 900) {
            desktop.show();
            mobile.hide();
        } else {
            mobile.show();
            desktop.hide();
        }

        $(".domesticRequirements-work-life-experience").hide();
    }

    displayDomesticWorkLifeExperience() {
        if (!this.domesticRequirementTables.length) return;

        $(".domesticRequirements-higher-education").hide();
        $(".domesticRequirements-secondary-education").hide();
        $(".domesticRequirements-vet-course").hide();

        let desktop =
            this.domesticRequirementTables.find(
                ".domesticRequirements-work-life-experience thead:not(.mobile), " +
                ".domesticRequirements-work-life-experience tbody:not(.mobile)"
            );

        let mobile =
            this.domesticRequirementTables.find(
                ".domesticRequirements-work-life-experience thead.mobile, " +
                ".domesticRequirements-work-life-experience tbody.mobile"
            );

        if (window.innerWidth >= 900) {
            desktop.show();
            mobile.hide();
        } else {
            mobile.show();
            desktop.hide();
        }
    }

    displayOtherRequirement(type) {
        if (
            type === "Honours" ||
            type === "Honors" ||
            type === "Postgraduate" ||
            type === "Research"
        ) {
            $("#otherRequirementContentBlock").show();
        } else {
            $("#otherRequirementContentBlock").hide();
        }
    }
    displaySpecialRequirement(type) {
        if (
            type === "Enabling" ||
            type === "Undergraduate" ||
            type === "Honors" ||
            type === "Postgraduate" ||
            type === "Research"
        ) {
            $("#special-requirement").show();
        } else {
            $("#special-requirement").hide();
        }
    }

    displayOnshoreRequirement(type) {
        if (type.toLowerCase() === "undergraduate") {
            $("#onshore-requirement").hide();
        } else {
            $("#onshore-requirement").show();
        }
    }

    displaySelectorCountry(type) {
        var closestHeadingPrev = this.selectCountryElemOriginal.prev("h5");
        var closestHeadingNext = this.selectCountryElemOriginal.next("h5");
        if (type === "Undergraduate") {
            closestHeadingPrev.show();
            closestHeadingNext.show();
            this.selectCountryElemOriginal.show();

            if (this.selectCountryElem?.length) {
                this.selectCountryElem.next().show();
            }

            $(".path-option").show();
        } else {
            closestHeadingPrev.hide();
            closestHeadingPrev.removeClass("d-inline-block");
            closestHeadingNext.hide();
            closestHeadingNext.removeClass("d-inline-block");
            this.selectCountryElemOriginal.hide();

            if (this.selectCountryElem?.length) {
                this.selectCountryElem.next().hide();
            }

            $(".path-option").hide();
        }
    }

    replaceQueryParam(param, newval, search) {
        var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
        var query = search.replace(regex, "$1").replace(/&$/, "");

        return (
            (query.length > 2 ? query + "&" : "?") +
            (newval ? param + "=" + newval : "")
        );
    }

    modifyEnquiryParam(userType) {
        if (userType) {
            const btns = document.getElementsByClassName("ask-btn");
            for (let i = 0; i < btns.length; i++) {
                let href = btns[i].href;
                btns[i].href = this.replaceQueryParam(
                    "user_type",
                    userType,
                    href
                );
            }
        }
    }

    handleStudentTypeSelection() {
        document.addEventListener("DOMContentLoaded", (event) => {
            this.toggleStudentTypeElements();
        });

        document.addEventListener("studentTypeChange", (event) => {
            this.toggleStudentTypeElements();
        });
    }

    toggleStudentTypeElements() {
        var currentStudentType = sessionStorage.getItem(
            "mu_student_type_url_name"
        );

        var toggleElements = document.querySelectorAll(
            "[data-student-type-toggle]"
        );

        if (currentStudentType !== null && toggleElements.length > 0) {
            toggleElements.forEach((element) => {
                if (element.dataset.studentTypeToggle === currentStudentType) {
                    element.style.display = "block";
                } else {
                    element.style.display = "none";
                }
            });
        }
    }

    displayActiveOfferings() {
        let studentType = this.getStudentTypeCookie();
        if (studentType === "domestic") {
            $(".offeringTable .domestic")
                .removeClass("active")
                .addClass("active");
            $(".offeringTable .international").removeClass("active");
        } else if (studentType === "international") {
            $(".offeringTable .international")
                .removeClass("active")
                .addClass("active");
            $(".offeringTable .domestic").removeClass("active");
        }
    }

    displayInternationalEntryRequirementsByCountry(countryName) {
        $(".internationalRequirements").hide();
        this.domesticRequirementTables.hide();
        var countryLength = this.selectCountryElem?.length || 0;
        let _atar = this.atar.trim();
        if (
            countryName != "" &&
            countryName != null &&
            countryName != this.str_australia &&
            countryLength > 0 &&
            this.atar != "" &&
            this.atar != null
        ) {
            let urlCountries =
                this.websiteUrl +
                "/api/CoursePageApi/EntryRequirements?Country=" +
                countryName +
                "&Discipline=" +
                this.discipline;
            $.ajax({
                url: urlCountries,
                crossDomain: true,
                cache: false,
                success: function (res) {
                    if (res.metadata.status == "200") {
                        let entryRequirements = res.EntryRequirements;
                        if (entryRequirements.length > 0) {
                            $(".internationalRequirements").show();
                            $(".internationalRequirements > tbody").show();
                            $(".internationalRequirements tr").remove();
                            $(
                                "#internationalRequirements-mobile table"
                            ).remove();
                            $("#internationalRequirements thead").append(
                                '<tr><th class="means-admission">Means of admission</th><th class="academic-requirement">Minimum academic requirement</th><th class="english-requirements">Minimum english requirement</th></tr>'
                            );
                            for (let i = 0; i < entryRequirements.length; i++) {
                                let html =
                                    "<tr><td>" +
                                    entryRequirements[i]["Qualification"] +
                                    "</td>" +
                                    "<td>" +
                                    entryRequirements[i]["ATAR" + _atar] +
                                    "</td>";
                                var html_mobile =
                                    '<table class="mobile"><tbody class="mobile"><tr><th class="means-admission">' +
                                    entryRequirements[i]["Qualification"] +
                                    "</th></tr>" +
                                    '<tr><td class="academic-requirement"><h4>Minimum academic requirement</h4>' +
                                    entryRequirements[i]["ATAR" + _atar] +
                                    "</td></tr>";

                                if (
                                    "EnglishRequirement" in
                                        entryRequirements[i] &&
                                    entryRequirements[i][
                                        "EnglishRequirement"
                                    ] !== ""
                                ) {
                                    html +=
                                        "<td>" +
                                        entryRequirements[i][
                                            "EnglishRequirement"
                                        ] +
                                        "</td></tr>";
                                    html_mobile +=
                                        "<tr><td><h4>Minimum english requirement</h4>" +
                                        entryRequirements[i][
                                            "EnglishRequirement"
                                        ] +
                                        "</td></tr>";
                                } else {
                                    html += "<td></td></tr>";
                                }
                                html_mobile += "<tbody></table>";
                                $("#internationalRequirements tbody").append(
                                    html
                                );
                                if (
                                    (entryRequirements[i]["Qualification"] + "")
                                        .length > 0
                                )
                                    $(
                                        "#internationalRequirements-mobile"
                                    ).append(html_mobile);
                                if (window.innerWidth >= 900) {
                                    $("#internationalRequirements").show();
                                    $(
                                        "#internationalRequirements > tbody"
                                    ).show();
                                    $(
                                        "#internationalRequirements-mobile"
                                    ).hide();
                                } else if (window.innerWidth < 900) {
                                    $("#internationalRequirements").hide();
                                    $(
                                        "#internationalRequirements-mobile"
                                    ).show();
                                }
                            }
                        }
                    }
                },
            });
        }
    }

    displayGenericAdmission() {
        let studentType = this.getStudentTypeCookie();
        if (studentType === "domestic") {
            $("#genericAdmissionContentBlock").show();
            $("#genericAdmissionContentBlock-International").hide();
        } else if (studentType === "international") {
            $("#genericAdmissionContentBlock-International").show();
            $("#genericAdmissionContentBlock").hide();
        }
    }

    getFeesAndScholarshipSelectorString(studentType) {
        let feesAndScholarshipSelectorString =
            "feesAndScholarship" +
            studentType.charAt(0).toUpperCase() +
            studentType.slice(1);
        feesAndScholarshipSelectorString =
            feesAndScholarshipSelectorString.replace(/\s/g, "");
        return feesAndScholarshipSelectorString;
    }

    getHowToApplySelectorString(semester, studentType) {
        let howToApplySelectorString =
            "howToApply" +
            semester +
            studentType.charAt(0).toUpperCase() +
            studentType.slice(1);
        howToApplySelectorString = howToApplySelectorString.replace(/\s/g, "");
        return howToApplySelectorString;
    }

    getStudentTypeCookie() {
        return this.getCookie("isStudentTypeDomestic") === "true"
            ? "domestic"
            : "international";
    }

    toggleFeesAndScholarshipVisibility(semester, studentType) {
        let feesAndScholarshipSelectorString =
            this.getFeesAndScholarshipSelectorString(semester, studentType);
        let feesAndScholarshipDiv = $("#" + feesAndScholarshipSelectorString);
        $(".feesAndScholarshipContentBlock").hide();
        feesAndScholarshipDiv.show();
    }

    setCookie(cname, cvalue, exdays) {
        let d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
}
